import React, { useState } from "react";
import ActionButtons from "../../preapps/ActionButtons";
import StatusBar from "../../preapps/StatusBar";
import PreappChildStatusBar from "./child-status/chils-status";
import moment from "moment";
const PreapChildRow = ({
    t,
    default_index,
    element,
    user,
    handleActiveBank,
    status2Percentage,
    showBanks,
    handleCancle,
    handlePdfRun,
    handleClick,
    activeId,
    handleAppCopy,
    handleChangeOwner,
    currentProgressName,
    isMerchant,
}) => {
    const [showButtons, setShowButtons] = useState(false);
    const handleShowButtons = () => {
        setShowButtons(true);
    };

    const handleHideButtons = () => {
        setShowButtons(false);
    };

    const CurrentProgressionIcon = (progressionId) => {
        if (progressionId < 5) {
            return "#b6d7a8";
        }
        if (progressionId > 4 && progressionId < 10) {
            return "#2b7fdb";
        }
        if (progressionId > 9 && progressionId < 14) {
            return "#e06666";
        }
        if (progressionId > 13 && progressionId < 17) {
            return "#ffa500";
        }
        if (progressionId > 16 && progressionId < 21) {
            return "#60d493";
        }
        if (progressionId > 20 && progressionId < 23) {
            return "#e61a26";
        }
        return "";
    };

    return (
        <div
            className={
                activeId === element[1].id
                    ? "table-div-tr-inner inner-child-row selected"
                    : "table-div-tr-inner inner-child-row"
            }
            key={element[default_index].id}
            onMouseLeave={() => {
                handleHideButtons();
            }}
            onMouseEnter={() => {
                handleShowButtons();
            }}
            onClick={(e) => handleClick(element[1].id, element[0])}
        >
            {isMerchant ? (
                <div
                    className="table-div-td col-id  col-id-hover"
                    onClick={(e) => handleActiveBank(element[default_index])}
                >
                    {element[default_index].id}
                </div>
            ) : (
                <>
                    {!showButtons && (
                        <div className="table-div-td col-status">
                            {t[1].form_type === 1 ? (
                                user?.channel == "sales_channel" ? (
                                    <StatusBar
                                        sales={true}
                                        currentStatus={currentProgressName(
                                            element[default_index]
                                                .lead_progression_id,
                                        )}
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(
                                            element[default_index],
                                        )}
                                        onClick={(e) =>
                                            handleActiveBank(
                                                element[default_index],
                                            )
                                        }
                                        statusColor={CurrentProgressionIcon(
                                            element[default_index]
                                                .lead_progression_id,
                                        )}
                                    />
                                ) : (
                                    <div
                                        className="text-right"
                                        onClick={(e) =>
                                            handleActiveBank(
                                                element[default_index],
                                            )
                                        }
                                    >
                                        Prevet Application
                                    </div>
                                )
                            ) : element[default_index] &&
                                element[default_index].progression_id <= 6 ? (
                                user?.channel == "sales_channel" ? (
                                    <StatusBar
                                        currentStatus={currentProgressName(
                                            element[default_index]
                                                .lead_progression_id,
                                        )}
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(
                                            element[default_index],
                                        )}
                                        onClick={(e) =>
                                            handleActiveBank(
                                                element[default_index],
                                            )
                                        }
                                        sales={true}
                                        statusColor={CurrentProgressionIcon(
                                            element[default_index]
                                                .lead_progression_id,
                                        )}
                                    />
                                ) : (
                                    <StatusBar
                                        currentStatus={
                                            element[default_index].progression
                                                ? element[default_index]
                                                    .progression.status
                                                : ""
                                        }
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(
                                            element[default_index],
                                        )}
                                        onClick={(e) =>
                                            handleActiveBank(
                                                element[default_index],
                                            )
                                        }
                                    />
                                )
                            ) : (
                                <PreappChildStatusBar
                                    t={element[default_index]}
                                />
                            )}
                        </div>
                    )}

                    {showButtons && (
                        <div
                            className="table-div-td col-id  col-id-hover"
                            onClick={(e) =>
                                handleActiveBank(element[default_index])
                            }
                        >
                            {element[default_index].id}
                        </div>
                    )}
                    <div className="table-div-td col-star star-content">
                        &nbsp;
                    </div>
                    {showButtons && (
                        <div className="table-div-td col-status">
                            {t[1].form_type === 1 ? (
                                user?.channel == "sales_channel" ? (
                                    <StatusBar
                                        sales={true}
                                        currentStatus={currentProgressName(
                                            element[default_index]
                                                .lead_progression_id,
                                        )}
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(
                                            element[default_index],
                                        )}
                                        onClick={(e) =>
                                            handleActiveBank(
                                                element[default_index],
                                            )
                                        }
                                        statusColor={CurrentProgressionIcon(
                                            element[default_index]
                                                .lead_progression_id,
                                        )}
                                    />
                                ) : (
                                    <div
                                        className="text-right"
                                        onClick={(e) =>
                                            handleActiveBank(
                                                element[default_index],
                                            )
                                        }
                                    >
                                        Prevet Application
                                    </div>
                                )
                            ) : element[default_index] &&
                                element[default_index].progression_id <= 7 ? (
                                user?.channel == "sales_channel" ? (
                                    <StatusBar
                                        sales={true}
                                        currentStatus={currentProgressName(
                                            element[default_index]
                                                .lead_progression_id,
                                        )}
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(
                                            element[default_index],
                                        )}
                                        onClick={(e) =>
                                            handleActiveBank(
                                                element[default_index],
                                            )
                                        }
                                        statusColor={CurrentProgressionIcon(
                                            element[default_index]
                                                .lead_progression_id,
                                        )}
                                    />
                                ) : (
                                    <StatusBar
                                        currentStatus={
                                            element[default_index].progression
                                                ? element[default_index]
                                                    .progression.status
                                                : ""
                                        }
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(
                                            element[default_index],
                                        )}
                                        onClick={(e) =>
                                            handleActiveBank(
                                                element[default_index],
                                            )
                                        }
                                    />
                                )
                            ) : (
                                <PreappChildStatusBar
                                    t={element[default_index]}
                                />
                            )}
                        </div>
                    )}

                    {!showButtons && (
                        <div
                            className="table-div-td col-id"
                            onClick={(e) =>
                                handleActiveBank(element[default_index])
                            }
                        >
                            {element[default_index].id}
                        </div>
                    )}

                    <div className="table-div-td col-merchant-dba">
                        <span
                            title={
                                element[default_index]?.bank?.name || (
                                    <>&mdash;</>
                                )
                            }
                        >
                            {user?.channel == "sales_channel"
                                ? element[default_index]?.sales_bank_name
                                : element[default_index]?.bank?.name || (
                                    <>&mdash;</>
                                )}
                        </span>
                    </div>
                    <div
                        className="table-div-td col-bank"
                        onClick={(e) =>
                            handleActiveBank(element[default_index])
                        }
                    ></div>
                    {user.role !== "agent" && (
                        <div className="table-div-td col-agent">&nbsp;</div>
                    )}
                    <div className="table-div-td col-action-buttons">
                        <ActionButtons
                            user={user}
                            preapp={element[default_index]}
                            showButtons={showButtons}
                            showAssignBank={false}
                            showMerchantColumn={true}
                            onAssignBank={() => showBanks()}
                            onCancel={(preapp) => handleCancle(preapp.id)}
                            onReRun={(preapp) => handlePdfRun(preapp.id)}
                            onCopy={(preapp) => handleAppCopy(preapp.id)}
                            onChangeOwnership={() => handleChangeOwner()}
                        />
                    </div>
                    <div className="table-div-td col-approved col-approved-child child">
                        {element[default_index]?.approved_at != null
                            ? moment(element[default_index].approved_at).format(
                                "MMM D, YYYY",
                            )
                            : ""}
                    </div>
                </>
            )}
        </div>
    );
};

export default PreapChildRow;
